import getLang from 'I18n/utils/getLang';
import { QueryHookOptions, RegisteredQuery } from 'data-fetching-client';
import { useAppContextQuery } from './useAppContextQuery';

export function usePersonalizationQuery<
  TName extends string,
  TVariables extends { language: string } & Record<string, any>,
  TResponse,
>(args: {
  app: RegisteredQuery<TName, TVariables, TResponse>;
  public: RegisteredQuery<TName, TVariables, TResponse>;
  options?: Omit<
    QueryHookOptions<Record<TName, TResponse>, TVariables>,
    'variables'
  > & {
    variables?: Partial<Pick<TVariables, 'language'>> &
      Omit<TVariables, 'language'>;
  };
}) {
  return useAppContextQuery({
    app: args.app,
    public: args.public,
    options: {
      ...args.options,
      variables: {
        ...(args.options?.variables ?? {}),
        language: getLang(),
      } as TVariables,
    },
  });
}
